import { useV2GetAccountQuery } from "@generated";
import useFlags from "@common/hooks/useFlags";
import { planTierEntitlements, resolvePlanTier } from "@utils/planTier";

// Entitlements follow the config.plan_tier flag (configPlanTier once
// camel-cased), not the account's `entitlements` attribute.
const useAccountHasEnetitlement = () => {
  const { data: account, isLoading, isError } = useV2GetAccountQuery({});
  const { configPlanTier } = useFlags() as Record<string, unknown>;
  const planTier = resolvePlanTier(configPlanTier);
  const entitlements = planTierEntitlements(planTier);

  const hasEntitlement = (entitlementToCheck: string): boolean =>
    entitlements.includes(entitlementToCheck);

  return {
    hasEntitlement,
    entitlements,
    planTier,
    isLoading,
    isError,
    account,
  };
};

export default useAccountHasEnetitlement;
